export default class HomeViewState {
  isVisible = false;
}
